/**
 * UnknownContactsPrompt — Gmail Sync unknown contacts.
 * Thin wrapper around UnknownContactsPanel.
 */

import UnknownContactsPanel from './UnknownContactsPanel.jsx';

function relDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return '';
  const days = Math.round((Date.now() - d.getTime()) / 86_400_000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days}d ago`;
}

export default function UnknownContactsPrompt({ items = [], getToken, firms, onAdd, onIgnore, onHandled }) {
  const normalized = items.map((it) => {
    const parts = [];
    if (it.direction === 'Inbound') parts.push('↩ replied');
    else if (it.direction === 'Outbound') parts.push('↗ you emailed');
    if (it.last_seen) parts.push(relDate(it.last_seen));
    if (it.subject) parts.push(`"${it.subject}"`);

    return {
      email:      it.email,
      name:       it.name || '',
      firm_guess: it.firm_guess || '',
      meta:       parts.join(' · '),
      source:     'Gmail Sync',
      prefill:    { _unmatchedEmail: it.email },
    };
  });

  const handleIgnore = onIgnore
    ? (email) => {
        const original = items.find((i) => i.email === email);
        if (original) onIgnore(original);
      }
    : null;

  const handleAdd = (prefill) => {
    onAdd?.({ ...prefill, source: 'Gmail Sync' });
    onHandled?.(prefill.email);
  };

  return (
    <UnknownContactsPanel
      title="Gmail Sync"
      icon="📥"
      bgColor="#eff6ff"
      borderColor="#bfdbfe"
      titleColor="#1d4ed8"
      items={normalized}
      getToken={getToken}
      firms={firms}
      onAdd={handleAdd}
      onIgnore={handleIgnore}
      onHandled={onHandled}
    />
  );
}
